export default () => ({ from: null, to: null });
